export const messages = {
  en: {
    editReserveService: {
      title: 'Edit Service',
      goodsName: 'Name',
      goodsNamePlaceholder: 'Required, please enter name',
      brand: 'Brand',
      brandPlaceholder: 'Please select brand',
      brandRequired: 'Brand cannot be empty',
      params: 'Parameters',
      paramsPlaceholder: 'Required, please select parameters',
      price: 'Service Fee',
      pricePlaceholder: 'Required, please enter service fee',
      sort: 'Sort',
      sortPlaceholder: 'Required, please enter sort',
      state: 'Status',
      statePlaceholder: 'Required, please select status',
      stateOff: 'Off Shelf',
      stateOn: 'On Shelf',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please select start date',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please select end date',
      imgUrl: 'Cover Image',
      goodsDesc: 'Description',
      goodsDescPlaceholder: 'Required, please enter description',
      content: 'Content',
      contentPlaceholder: 'Required, please enter content'
    },
    uploadImage: {
      sizeLimit: 'Image size cannot exceed 2MB',
      uploadError: 'Upload failed'
    }
  },
  zh: {
    editReserveService: {
      title: '编辑服务',
      goodsName: '名称',
      goodsNamePlaceholder: '必填，请填写名称',
      brand: '品牌',
      brandPlaceholder: '请选择品牌',
      brandRequired: '品牌不能为空',
      params: '参数',
      paramsPlaceholder: '必填，请选择参数',
      price: '上门费',
      pricePlaceholder: '必填，请填写上门费',
      sort: '排序',
      sortPlaceholder: '必填，请填写排序',
      state: '状态',
      statePlaceholder: '必填，请选择状态',
      stateOff: '未上架',
      stateOn: '上架',
      startDate: '开始时间',
      startDatePlaceholder: '必填，请填写开始时间',
      endDate: '结束时间',
      endDatePlaceholder: '必填，请填写结束时间',
      imgUrl: '产品封面',
      goodsDesc: '商品简介',
      goodsDescPlaceholder: '必填，请填写商品简介',
      content: '商品详情',
      contentPlaceholder: '必填，请输入商品描述'
    },
    uploadImage: {
      sizeLimit: '图片大小不能超过2MB',
      uploadError: '上传失败'
    }
  }
}